export default (err, errMsg = null) => {
    if(!err.response) return toastr.error(err.message);

    const { data: { errors, message } } = err.response;
    const messages = [];
    !!errMsg && messages.push(errMsg);
    messages.push(message);
    Object.keys(typeof(errors) !== 'undefined'? errors: {}).map(key => {
        const fieldErrors = errors[key];
        fieldErrors.map(errMsg => messages.push(errMsg));
    });

    return toastr.error(messages.join('\n'));
}